import { withLayout } from 'pages/Layout'

import HomePage from './HomePage'

export default withLayout('home', HomePage)
